import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'ngbd-modal-confirm-autofocus',
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="modal-title">Post deletion</h4>
      <button
        type="button"
        class="close"
        aria-label="Close button"
        aria-describedby="modal-title"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>
        <strong
          >Are you sure you want to delete the post with the title
          <span class="text-primary">"{{ title }}"</span></strong
        >
      </p>
      <p>
        <span class="text-danger">This operation can not be undone.</span>
      </p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="modal.dismiss('cancel click')"
      >
        Cancel
      </button>
      <button
        type="button"
        ngbAutofocus
        class="btn btn-danger"
        (click)="modal.close('Ok click')"
      >
        Delete
      </button>
    </div>
  `,
  standalone: false,
})
export class NgbdModalConfirmAutofocus {
  constructor(public modal: NgbActiveModal) {}

  @Input() id: string;
  @Input() title: string;
}

@Component({
  selector: 'table-cmp',
  templateUrl: 'table.component.html',
  standalone: false,
})
export class TableComponent implements OnInit {
  withAutofocus = `<button type="button" ngbAutofocus class="btn btn-danger"
      (click)="modal.close('Ok click')">Ok</button>`;
  constructor(
    private router: Router,
    private http: HttpClient,
    private _modalService: NgbModal
  ) {}
  public tableData1: TableData;
  public tableData2: TableData;

  public posts: Post[];

  loading: boolean = false;

  ngOnInit() {
    this.loading = true;
    this.fetchPosts().subscribe((response) => {
      this.loading = false;
      this.posts = response.map((item) => {
        const createdAt = item.createdAt.substring(0, 10);
        const id = item.id;
        const title = item.title;
        const content = item.content.substring(0, 150) + '...';
        const pictureUrl = item.pictureUrl;
        return { createdAt, id, title, content, pictureUrl };
      });
    });
  }

  fetchPosts(): Observable<Post[]> {
    return this.http.get<any>(
      'https://pedro-app-rest-api.herokuapp.com/posts/english'
    );
  }

  navigateToView(id: string) {
    this.router.navigateByUrl(`/admin/posts/view/${id}`);
  }

  navigateToEdit(id: string) {
    this.router.navigateByUrl(`/admin/posts/edit/${id}`);
  }

  open(id: string, title: string) {
    const modalRef = this._modalService.open(NgbdModalConfirmAutofocus);
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.title = title;

    modalRef.result
      .then((result) => {
        this.deletePostById(id);
      })
      .catch((error) => {
        console.log('it was click the cancel button');
      });
  }

  deletePostById(id: string) {
    this.http
      .delete<any>(`https://pedro-app-rest-api.herokuapp.com/posts/${id}`)
      .subscribe((response) => {
        window.location.reload();
      });
  }
}

declare interface TableData {
  headerRow: string[];
  dataRows: string[][];
}

interface Post {
  id: string;
  title: string;
  content: string;
  pictureUrl: string | null;
  createdAt: string;
}
